import createCachedSelector from 're-reselect'
import * as R from 'ramda'

const dataTablePath = ['dataTable']

const idProp = R.prop('id')
// sortBySelector :: (State, Props) -> String
export const sortBySelector = (state, props) =>
  R.path([...dataTablePath, 'sortBy', idProp(props)], state)

export const getSortBySelector = id => state => sortBySelector(state, { id })

// isSortAscendingSelector :: (State, Props) -> Boolean
export const isSortAscendingSelector = (state, props) =>
  R.path([...dataTablePath, 'isSortAscending', idProp(props)], state)

export const getIsSortAscendingSelector = id => state =>
  isSortAscendingSelector(state, { id })

// sortedDataSelector :: (State, Props) -> Array
export const sortedDataSelector = createCachedSelector(
  sortBySelector,
  isSortAscendingSelector,
  (state, props) => R.prop('data', props),
  (state, props) => R.prop('columns', props),
  (sortBy, isSortAscending, data, columns) => {
    const sortByColumn = R.find(
      R.propEq('title', sortBy),
      R.defaultTo([], columns)
    )
    const getProp = n => {
      if (sortByColumn) {
        if (typeof sortByColumn.sortProperty === 'function') {
          return sortByColumn.sortProperty(n)
        }

        if (typeof sortByColumn.property === 'function') {
          return sortByColumn.property(n)
        }
        return R.prop(sortByColumn.property, n)
      }
      return null
    }

    if (!R.isNil(getProp) && !R.isNil(isSortAscending)) {
      return R.sort((a, b) => {
        const propA = getProp(a)
        const propB = getProp(b)

        if (Number.isNaN(propA)) {
          return 1
        } else if (Number.isNaN(propB)) {
          return -1
        } else if (propA === propB) {
          return 0
        } else if (isSortAscending) {
          return propA < propB ? -1 : 1
        }
        return propA < propB ? 1 : -1
      }, data)
    }

    return data
  }
)((state, props) => props.id)
